import { saveAs } from 'file-saver';
import { utils, writeFile } from 'xlsx';

export const convertJsonToCsv = jsonData => {
  const data = typeof jsonData !== 'object' ? JSON.parse(jsonData) : jsonData;
  let csv = '';
  csv += '\uFEFF';
  for (let i = 0; i < data.length; i += 1) {
    const values = Object.values(data[i]).map(value => {
      if (typeof value === 'string' && value.includes(',')) {
        return `"${value}"`; // Enclose value in double quotes if it contains a comma
      }
      return value;
    });
    csv += `${values.join(',')}\n`;
  }
  return csv;
};

export const downloadCsvFile = (data, fileName) => {
  const BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([BOM, data], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, `${fileName}.csv`);
};

export const downloadCsvFromJSON = (data, fileName) => {
  const csv = convertJsonToCsv(data);
  downloadCsvFile(csv, fileName);
};

export const downloadCsvFromBase64 = (data, fileName) => {
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  downloadCsvFile(bytes, fileName);
};

export const downloadXLSXFile = (blob, fileName) => {
  saveAs(blob, `${fileName}.xlsx`);
};

export const downloadXLSXFromJSON = (data, fileName) => {
  const worksheet = utils.json_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet);
  writeFile(workbook, `${fileName}.xlsx`);
};

export const downloadBase64FromPDF = (data, fileName) => {
  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  saveAs(blob, fileName);
};
